import React from "react";
import { Helmet } from "react-helmet";

const AvisClient: React.FC = () => {
  const canonicalUrl = "https://www.lapeyre.fr/avis-clients";
  const pageTitle = "Tous les avis clients | Lapeyre";
  const pageDescription = "Avis clients Lapeyre";

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      {/* <div dangerouslySetInnerHTML={{ __html: htmlContent }} /> */}
      <div style={{ width: "100%", minHeight: "2400px" }}>
        <iframe
          title="Avis Clients Lapeyre"
          src="https://www.avis-verifies.com/avis-clients/lapeyre.fr"
          style={{ width: "100%", minHeight: "54000px", border: "0", display: "block" }}
          scrolling="no"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </>
  );
};

export default AvisClient;
